import React from 'react';
import './css/Notification.css';

export const Notification = ({ message, type, visible, onClose }) => {
  if (!visible) return null;
  
  return (
    <div className={`notification ${type} relative font-ui`}>
      <p className='pr-2'>{message}</p>
      {onClose && (
        <button 
          onClick={onClose} 
          aria-label="Close notification"
          className="absolute top-2 right-3 text-xl leading-none hover:opacity-70 font-bold"
        >
          ×
        </button>
      )}
    </div>
  );
}; 